import { openBlock as e, createElementBlock as a, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M6.67 2.933a.75.75 0 0 1 .684-.441h7.27a.75.75 0 0 1 .683.44l.496 1.098.269.594.035.078h2.606v1.5h-3.089a.752.752 0 0 1-.671-.415c-.013-.026-.245-.539-.473-1.043l-.34-.752H7.838L7.047 5.74a.75.75 0 0 1-.683.44h-3.1l-.02.002V17.98a.25.25 0 0 0 .02 0h10.27a.75.75 0 0 1 0 1.5H3.264c-.664 0-1.52-.445-1.52-1.35V6.03c0-.446.237-.798.517-1.015.28-.218.637-.334 1.003-.334H5.88l.79-1.75Zm12.063 3.27a.19.19 0 0 0-.02-.001v-1.5c.723 0 1.52.513 1.52 1.4v6.49a.75.75 0 0 1-1.5 0v-6.39Zm-7.74 3.359a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-4 2.5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm12.5 3.92a.75.75 0 0 1 .75.75v1.25h1.25a.75.75 0 0 1 0 1.5h-1.25v1.25a.75.75 0 0 1-1.5 0v-1.25h-1.25a.75.75 0 0 1 0-1.5h1.25v-1.25a.75.75 0 0 1 .75-.75Z",
  "clip-rule": "evenodd"
}, null, -1), l = [
  c
];
function n(h, r) {
  return e(), a("svg", o, [...l]);
}
const v = { render: n };
export {
  v as default,
  n as render
};
